export default {
    name: "error",
    data() {
        return {

        }
    },
    methods: {
        openIndex() {
            this.$router.push({path: "/index"})
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/404/index.js